<chart-details-layout 
    [chartDetails]="chartDetails" 
    [isLoading]="isLoading"
    [showFormButtons]="showFormButtons"
    (save)="onSaveSettings()"
    (cancel)="onRevertSettings()">
    <app-language-chart chart [showTitle]="false"></app-language-chart>
    <base-details detailsComponent
        *ngIf="!isLoading"
        [chartDetails]="chartDetails"
        [generalSettings]="config?.generalSettings"
        (generalSettingsChange)="onGeneralSettingsChange($event)"
    >
    </base-details>
</chart-details-layout>
